import type { JiraIssue } from '../../types';

export const isJiraIssue = (entity: any): entity is JiraIssue => {
	return entity.__typename === 'JiraIssue';
};

export const getJiraIssueLink = (issue: JiraIssue): string | null => {
	return issue?.webUrl ?? null;
};
